module.exports = "/_next/static/festival-bw.1da7d7655966441821e604548d64a731.css";